import { useMemo, useCallback } from 'react'
import { Country } from '@pylot-data/pylotschema'
import { usePreloadedData } from '@preload'

export type OutputInterface = {
    data: {
        countries: Country[]
    }
}

export const useCountries = () => {
    const swrResponse = (usePreloadedData(
        'countries'
    ) as unknown) as OutputInterface

    const countries = useMemo(() => {
        return (
            swrResponse?.data?.countries?.sort((a, b) =>
                String(a?.full_name_locale)?.localeCompare(
                    String(b?.full_name_locale)
                )
            ) || []
        )
    }, [swrResponse])

    const countryNameLocale = useMemo(() => {
        const countryMap = new Map()

        if (countries) {
            countries.forEach((country) => {
                countryMap.set(
                    country.two_letter_abbreviation,
                    country.full_name_locale
                )
            })
        }

        return countryMap
    }, [countries])

    const getCountryByCode = useCallback(
        (code: string): Country[] | [] => {
            if (!countries) return []
            return countries.filter(
                (country) => country?.two_letter_abbreviation === code
            )
        },
        [countries]
    )

    return {
        countries,
        countryNameLocale,
        getCountryByCode
    }
}
